import { Injectable, Output, EventEmitter, Directive } from "@angular/core";

@Directive()
@Injectable()
export class popupService{

    @Output() openSpeedbump = new EventEmitter<any>();
    @Output() closeSpeedbump = new EventEmitter<any>();
    @Output() openCenteredSpeedbump = new EventEmitter<any>();
    @Output() closeCenteredSpeedbump = new EventEmitter<any>();
    @Output() openTncMarketingPopup = new EventEmitter<any>();
    @Output() closeTncMarketingPopup = new EventEmitter<any>();
    @Output() openMFAModal = new EventEmitter<any>();
    @Output() closeMFAModal = new EventEmitter<any>();
    @Output() mfaOverlay = new EventEmitter<boolean>();

    // common crs dropdown close
    @Output() crsDropDownClose = new EventEmitter<any>();
    @Output() crsDropDownOpen = new EventEmitter<any>();
    @Output() crsDropDownSelected = new EventEmitter<any>();
    @Output() crsDropDownReset = new EventEmitter<any>();
}
